module.exports = __webpack_public_path__ + "img/pairing.b4d517cf.svg";